var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-list',{attrs:{"title":"Transaksi Berhasil","data-url":"/api/v1/po/intransit","data-size":"10","previewUrl":"/po/preview/:id:?preview=true&rollback=/po/process&printurl=/print/po/faktur","dataHeaders":_vm.tHeaders}})}
var staticRenderFns = []

export { render, staticRenderFns }